export default "__VITE_ASSET__CHNym$$X__"